/**
 * @module experience/lost-stolen
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const LOST_STOLEN_CONSTANT = {
  LOST_STOLEN_STATUS: 'ELSTS',
  REACTIVE_STATUS: 'REACS',
  NO: 'No',
  BLOCK: 'BLOCK',
  UNBLOCK: 'UNBLOCK',
  RESTORE: 'RESTORE',
  ACTIVE: 'ACT',
  STOLEN: '4',
  FAC: 'FAC',
};
